<template>
  <div class="boxes">
    <h3><Icon type="md-bookmarks" />报警趋势分析<slot name="right"></slot></h3>
    <Row>
      <Col span="6">
        <ly-form-item label="本周期报警：" lw="6"
          >{{ item.alarmTotal }}次</ly-form-item
        >
      </Col>
      <Col span="6">
        <ly-form-item label="上周期报警：" lw="6"
          >{{ item.lastTotal }}次</ly-form-item
        >
      </Col>
      <Col span="6">
        <ly-form-item label="同比增长率：" lw="6">
          <Icon
            v-if="item.contrast === 0"
            type="md-remove"
            color="blue"
            size="15"
          />
          <Icon
            v-else-if="item.contrast === 1"
            type="md-arrow-round-up"
            color="red"
            size="15"
          />
          <Icon
            v-else-if="item.contrast === 2"
            type="md-arrow-round-down"
            color="green"
            size="15"
          />
          {{ type[item.contrast] }}{{ item.contrastRate }}%
        </ly-form-item>
      </Col>
    </Row>
    <div id="baojingfenxi"></div>
  </div>
</template>
<script>
export default {
  //0-持平，1-上升，2，下降
  data() {
    return {
      persons: {
        xData: ["10-01", "10-02", "10-03", "10-04", "10-05", "10-06", "10-07"],
        yData: [43.23, 53.24, 87.42, 54.21, 76.34, 95.54, 71.67],
      },
      item: {
        alarmTotal: 1332,
        lastTotal: 2125,
        contrast: 2,
        contrastRate: 37.32,
        dateList: [],
        alarmList: [],
      },
      type: {
        0: "持平",
        1: "上升",
        2: "下降",
      },
    };
  },
  methods: {
    getData(v) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-oam/report/countAlarm",
        data: v,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        var time = data.dateList;
        for (let j = 0; j < time.length; j++) {
          time[j] = this.utils.time(time[j], "mmdd");
        }
        this.item = data;
        this.drawBar();
      });
    },
    drawBar(obj) {
      this.chart = this.echarts.init(document.getElementById("baojingfenxi"));

      this.option = {
        backgroundColor: "#fff",
        grid: {
          x: 30,
          y: 30,
          x2: 30,
          y2: 50, //距离下边的距离
        },
        /* dataZoom: [
          {
            type: "inside",
            //type: "slider",
            start: 0, //放大起点
            //end: this.list.length<500?100:100/(this.list.length/500) //放大终点
            end: 100, //放大终点
          },
        ], */
        xAxis: {
          type: "category",

          data: this.item.dateList,
          axisLabel: { rotate: 45 },
        },
        yAxis: {
          type: "value",
        },
        color: "#fc3d3d",
        series: [
          {
            data: this.item.alarmList,
            smooth: 0.4,
            // 设置折线上圆点大小
            symbolSize: 10,

            type: "line",
            label: {
              show: true,
              position: "top",
            },
            itemStyle: {
              normal: {
                // color: "#6cb041",
                lineStyle: {
                  width: 4, //设置线条粗细
                },
              },
            },
            areaStyle: {
              //color: "#ff7c25",
              opacity: "0.9",
              //shadowColor: "#000",
              // shadowBlur: 50,
              //shadowOffsetX:0,
              // shadowOffsetY:-10
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#ffd1d1",
                },
                {
                  offset: 1,
                  color: "#ffd1d1",
                },
              ]),
            },
          },
        ],
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return val.name + "（" + val.value + "）";
          },
        },
      };
      this.chart.setOption(this.option);
      this.chart.resize();
    },
  },
  mounted() {
    this.drawBar();
  },
};
</script>
<style>
#baojingfenxi {
  width: 100%;
  height: 500px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/anaReports/baojingfenxi.vue